import PageRenderer from '../../components/PageRenderer/PageRenderer';

function Contact() {
  return <PageRenderer pageKey="contact" />;
}

export default Contact;
